import React, { Component } from 'react';
import { map } from 'lodash';
import { hot } from 'react-hot-loader';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import {
  Button,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(0.875),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="button">{children}</Typography>
      {onClose ? (
        <IconButton
          color="secondary"
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: props => (props.withPadding ? theme.spacing(2) : 0)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`
  }
}))(MuiDialogActions);

class CustomDialog extends Component {
  state = {
    open: Boolean(this.props.open)
  };

  static getDerivedStateFromProps = (props, state) => {
    return {
      ...state,
      open: props.open
    };
  };

  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const {
      withPadding,
      buttons,
      title,
      children,
      width,
      maxWidth = 'md',
      fullScreen,
      style
    } = this.props;
    const { open } = this.state;
    const fs = fullScreen || !isWidthUp('sm', width);

    return (
      <Dialog
        fullScreen={fs}
        fullWidth
        maxWidth={maxWidth}
        onClose={this.handleClose}
        aria-labelledby="dialog-title"
        open={open}
        style={{ ...style }}
      >
        <DialogTitle id="dialog-title" onClose={this.handleClose}>
          {title}
        </DialogTitle>
        <DialogContent withPadding={withPadding}>{children}</DialogContent>
        {buttons && buttons.length && (
          <DialogActions>
            {map(buttons, button => (
              <Button
                // ref={ref => {
                //   if (ref) {
                //     ref.focus();
                //   }
                // }}
                key={button.label}
                onClick={button.onClick}
                variant={button.variant}
                color={button.color}
              >
                {button.label}
              </Button>
            ))}
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default hot(module)(withWidth()(CustomDialog));
